module.exports = __webpack_public_path__ + "static/media/fa-brands-400.4019e2ef.woff2";